<template>
  <div class="flex flex-col px-[46px] w-[1048px] gap-[50px] py-[50px]">
    <h3 class="text-grays-900 text-xl font-medium">
      רק עוד כמה פרטים קטנים, ותוכלו להתחיל את הקניה.
    </h3>
    <div class="flex flex-col gap-[30px]">
      <!-- User details forms -->
      <div class="flex flex-col w-full gap-[16px]">
        <p class="text-primary-700 text-xl font-medium">פרופיל משפחתי</p>
        <div class="flex flex-row w-full gap-[14px]">
          <div class="flex flex-row w-full gap-[20px]">
            <input-default
              :error="v$.lname.$error"
              :errorMessage="v$.lname.$errors[0]?.$message"
              :label="'שם משפחה'"
              :model-value="lname"
              @update:model-value="setLname"
            />
            <input-default
              :error="v$.fname.$error"
              :errorMessage="v$.fname.$errors[0]?.$message"
              :label="'שם פרטי'"
              :model-value="fname"
              @update:model-value="setFname"
            />
            <input-default
              :error="v$.idNumber.$error"
              :errorMessage="v$.idNumber.$errors[0]?.$message"
              :label="'תעודת זהות'"
              :model-value="idNumber"
              @update:model-value="setIdNumber"
            />
          </div>
          <div class="flex flex-row w-full gap-[20px]">
            <input-default
              :error="v$.city.$error"
              :errorMessage="v$.city.$errors[0]?.$message"
              :label="'עיר'"
              :model-value="city"
              @update:model-value="setCity"
            />
            <input-default
              :error="v$.street.$error"
              :errorMessage="v$.street.$errors[0]?.$message"
              :label="'רחוב'"
              :model-value="street"
              @update:model-value="setStreet"
            />
          </div>
          <div
            v-for="(phoneNumber, index) in allPhoneNumbers"
            :key="index"
            class="w-fit flex gap-4"
          >
            <input-default
              :error="
                (index === 0
                  ? !this.v$.allPhoneNumbers.firstPhoneRequire.$response
                  : false) ||
                (v$.allPhoneNumbers.$each.$response.$errors
                  ? !!v$.allPhoneNumbers.$each.$response.$errors[index].tel
                      .length
                  : false)
              "
              :errorMessage="
                index === 0 &&
                !this.v$.allPhoneNumbers.firstPhoneRequire.$response
                  ? this.v$.allPhoneNumbers.firstPhoneRequire.$message.toString()
                  : v$.allPhoneNumbers.$each.$response.$errors &&
                    v$.allPhoneNumbers.$each.$response.$errors[index].tel.length
                  ? v$.allPhoneNumbers.$each.$response.$errors[index].tel[0]
                      .$message
                  : ''
              "
              :label="'טלפון ' + (index + 1)"
              :model-value="phoneNumber.tel"
              @update:model-value="updatePhoneNumber(index, $event)"
            />
            <button
              v-if="allPhoneNumbers.length > 1"
              class="mt-8 h-fit"
              @click="deletePhone(index)"
            >
              <span class="material-symbols-rounded text-lg text-grays-800"
                >delete</span
              >
            </button>
          </div>
          <button-text class="mt-[25px]" @click="addNewPhone">
            <span class="material-symbols-rounded text-lg">add</span>
            עוד מספר טלפון
          </button-text>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useValidate from "@vuelidate/core";
import { userValidation } from "@/validation/User";
import InputDefault from "@/components/Global/InputDefault.vue";
import { mapGetters, mapMutations } from "vuex";
import ButtonText from "@/components/Global/ButtonText.vue";
import axiosInstance from "@/helpers/axios";
import { toRaw } from "vue";

export default {
  name: "CompleteRegistrationPage1",
  components: { ButtonText, InputDefault },

  data() {
    return {
      v$: useValidate(),
      validateNewPhones: false,
      requestError: false,
      profileData: {},
    };
  },
  validations() {
    return {
      idNumber: userValidation.idNumber,
      fname: userValidation.fname,
      lname: userValidation.lname,
      street: userValidation.street,
      city: userValidation.city,
      allPhoneNumbers: userValidation.allPhoneNumbers,
    };
  },
  methods: {
    ...mapMutations({
      setIdNumber: "user/setIdNumber",
      setFname: "user/setFname",
      setLname: "user/setLname",
      setStreet: "user/setStreet",
      setCity: "user/setCity",
      addPhone: "user/addPhone",
      setAllPhoneNumbers: "user/setAllPhoneNumbers",
      deleteAllNullPhoneNumbers: "user/deleteAllNullPhoneNumbers",
    }),
    deletePhone(index) {
      this.allPhoneNumbers.splice(index, 1);
    },
    addNewPhone() {
      this.addPhone({ tel: "", no_msg: 0 });
    },
    updatePhoneNumber(index, value) {
      this.setAllPhoneNumbers({ index, value });
    },
    validateForm() {
      let isValid = false;
      this.v$.$validate();
      this.validateNewPhones = true;
      if (!this.v$.$error) {
        this.deleteAllNullPhoneNumbers();
        isValid = true;
      }
      return isValid;
    },
    async getProfileData() {
      try {
        const response = await axiosInstance.get("/profile");
        this.profileData = response.data;
        this.$store.dispatch(
          "findStation/updateAddress",
          this.profileData.site.street
        );
      } catch (error) {
        console.error(error);
      }
    },
  },
  mounted() {
    this.getProfileData();
  },
  computed: {
    ...mapGetters({
      lname: "user/getLname",
      fname: "user/getFname",
      idNumber: "user/getIdNumber",
      city: "user/getCity",
      street: "user/getStreet",
      allPhoneNumbers: "user/getAllPhoneNumbers",
    }),
  },
  watch: {
    allPhoneNumbers() {},
    profileData: {
      deep: true,
      handler(updatedData) {
        const rawData = toRaw(updatedData).phones.map((item) => item.tel);
        this.setFname(updatedData.fname);
        this.setLname(updatedData.lname);
        this.setIdNumber(updatedData.tzl);
        this.setStreet(updatedData.street);
        this.setCity(updatedData.city);
        rawData.forEach((value, index) => {
          this.setAllPhoneNumbers({ index, value });
        });
      },
    },
  },
};
</script>

<style scoped>
</style>
